import { render, staticRenderFns } from "./XoaVaiTroThuocNguoiDungModal.vue?vue&type=template&id=5db507d2&"
import script from "./XoaVaiTroThuocNguoiDungModal.vue?vue&type=script&lang=js&"
export * from "./XoaVaiTroThuocNguoiDungModal.vue?vue&type=script&lang=js&"
import style0 from "./XoaVaiTroThuocNguoiDungModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports